import { isApiVersionGte } from "../../../utils/deviceApiVersion";

export const MIN_SHELL_API_VERSION = "1.2";

export const SHELL_API_VERSION_REASON = {
  COMPATIBLE: "COMPATIBLE",
  MISSING_API_VERSION: "MISSING_API_VERSION",
  API_VERSION_TOO_LOW: "API_VERSION_TOO_LOW",
};

const normalizeRawVersion = (apiVersionRaw) => {
  if (apiVersionRaw === undefined || apiVersionRaw === null) {
    return "";
  }

  return String(apiVersionRaw).trim();
};

export const evaluateShellApiVersion = (apiVersionRaw) => {
  const normalizedRawVersion = normalizeRawVersion(apiVersionRaw);
  if (!normalizedRawVersion) {
    return {
      isCompatible: false,
      apiVersionRaw: apiVersionRaw ?? null,
      apiVersionNumber: null,
      reasonCode: SHELL_API_VERSION_REASON.MISSING_API_VERSION,
    };
  }

  const apiVersionNumber = Number.parseFloat(normalizedRawVersion);
  if (!Number.isFinite(apiVersionNumber)) {
    return {
      isCompatible: false,
      apiVersionRaw,
      apiVersionNumber: null,
      reasonCode: SHELL_API_VERSION_REASON.MISSING_API_VERSION,
    };
  }

  if (!isApiVersionGte(normalizedRawVersion, MIN_SHELL_API_VERSION)) {
    return {
      isCompatible: false,
      apiVersionRaw,
      apiVersionNumber,
      reasonCode: SHELL_API_VERSION_REASON.API_VERSION_TOO_LOW,
    };
  }

  return {
    isCompatible: true,
    apiVersionRaw,
    apiVersionNumber,
    reasonCode: SHELL_API_VERSION_REASON.COMPATIBLE,
  };
};
